import { Building2, Landmark, Scale, Compass, Plane, Diamond, Megaphone, HandCoins, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

const FIELDS = [
  { name: "Real Estate", desc: "Site thesis, capital stack, and the long arc of placemaking.", icon: Building2 },
  { name: "Finance", desc: "Structuring, syndication, and the discipline of conviction capital.", icon: Landmark },
  { name: "Government Policy", desc: "Regulatory navigation, public-private design, sovereign strategy.", icon: Scale },
  { name: "Architecture", desc: "From thesis to brief to award-winning, occupied buildings.", icon: Compass },
  { name: "Travel & Tourism", desc: "Destination strategy, hospitality positioning, jurisdictional branding.", icon: Plane },
  { name: "Luxury Retail", desc: "Brand architecture, distribution doctrine, and the economics of restraint.", icon: Diamond },
  { name: "Marketing", desc: "Editorial-grade brand building for institutions that play long.", icon: Megaphone },
  { name: "Fund Raising", desc: "Capital narratives, investor design, and the choreography of close.", icon: HandCoins },
];

export default function Fields() {
  return (
    <section id="fields" className="relative max-w-7xl mx-auto px-6 lg:px-10 py-24" data-testid="fields-section">
      <div className="grid grid-cols-12 gap-6 items-end mb-12">
        <div className="col-span-12 md:col-span-7">
          <p className="overline">Fields of Practice</p>
          <h2 className="font-display font-light text-4xl lg:text-5xl tracking-tight mt-4">
            Eight disciplines. <br />
            <span className="italic text-[var(--pov-cyan)]">One point of view.</span>
          </h2>
        </div>
        <div className="col-span-12 md:col-span-5 text-white/60 text-sm md:text-right">
          We work across these fields because they bleed into one another — every great real estate
          play is also a policy play, every brand is also an act of capital.
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/5 rounded-sm overflow-hidden">
        {FIELDS.map(({ name, desc, icon: Icon }, idx) => (
          <article
            key={name}
            className="field-card p-8 min-h-[230px] flex flex-col justify-between"
            data-testid={`field-card-${name.toLowerCase().replace(/ /g, "-").replace(/&/g, "and")}`}
          >
            <div>
              <div className="flex items-center justify-between">
                <span className="font-display text-xs text-white/40">0{idx + 1}</span>
                <Icon className="w-5 h-5 text-[var(--pov-cyan)]" />
              </div>
              <p className="font-display text-xl mt-6">{name}</p>
              <p className="text-sm text-white/60 mt-3 leading-relaxed">{desc}</p>
            </div>
            <Link to="/book" className="mt-6 text-xs text-white/50 hover:text-[var(--pov-coral)] transition-colors inline-flex items-center gap-1 group">
              Engage <ArrowUpRight className="w-3 h-3 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </Link>
          </article>
        ))}
      </div>
    </section>
  );
}
